import React, { useState } from 'react';
import Navbar from '../Layout/Navbar';
import './Legal.css';

const ContactUs: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/api/races/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Failed');
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="legal-page">
      <Navbar />
      <div className="legal-container legal-container-narrow">
        <h1>Contact Us</h1>
        <p className="legal-subtitle">Have a question, found a bug, or want to list your race? We'd love to hear from you.</p>

        {status === 'sent' && (
          <div className="legal-success">Message sent! We'll get back to you within 5 business days.</div>
        )}

        {status === 'error' && (
          <div className="legal-error">Something went wrong. Please email us directly instead.</div>
        )}

        {status !== 'sent' && (
          <form className="legal-form" onSubmit={handleSubmit}>
            <div className="legal-form-group">
              <label>Name</label>
              <input
                type="text"
                required
                value={form.name}
                onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                placeholder="Your name"
              />
            </div>
            <div className="legal-form-group">
              <label>Email</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
                placeholder="your@email.com"
              />
            </div>
            <div className="legal-form-group">
              <label>Message</label>
              <textarea
                required
                rows={6}
                value={form.message}
                onChange={e => setForm(p => ({ ...p, message: e.target.value }))}
                placeholder="How can we help?"
              />
            </div>
            <button type="submit" className="legal-submit-btn" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
